<template>
  <div>
    <v-row
      v-for="(linha, linhaIdx) in celulas"
      :key="linhaIdx"
      :class="rowClasses"
    >
      <template v-for="(componenteData, componenteIdx) in linha">
        <celula
          v-if="componenteData.visivel"
          :key="componenteIdx"
          :componente-data="componenteData"
          :celula-options="new CelulaOptions({ qtdColunasPorCelula, elevation: 0, justifyCenter, handleInputChange })"
          :celula-componente-options="getCelulaComponenteOptions(componenteData)"
          :componente-assinatura-options="getComponenteAssinaturaOptions(componenteData)"
          :componente-text-label-options="componenteTextLabelOptions"
          :componente-arquivo-options="getComponenteArquivoOptions(componenteData)"
        />
      </template>
    </v-row>
  </div>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api'
import Celula from '@/views/formulario/celulas/Celula.vue'
import ComponenteTextLabelOptions from '@/models/props/ComponenteTextLabelOptions'
import ComponenteAssinaturaOptions from '@/models/props/ComponenteAssinaturaOptions'
import CelulaComponenteOptions from '@/models/props/CelulaComponenteOptions'
import CelulaOptions from '@/models/props/CelulaOptions'
import ComponenteArquivoOptions from '@/models/props/ComponenteArquivoOptions'
import TiposDeComponentesEnum from '@/models/entities/formulario/componente/TiposDeComponentesEnum'

export default {
  components: {
    Celula,
  },

  props: {
    ticketId: {
      type: Number,
      required: true,
    },
    formularioId: {
      type: Number,
      required: true,
    },
    qtdColunas: {
      type: Number,
      required: true,
    },
    elementos: {
      type: Array,
      required: true,
    },
    readonly: Boolean,
    justifyCenter: Boolean,
    alignCenter: Boolean,
    componenteTextLabelOptions: {
      type: ComponenteTextLabelOptions,
      default: null,
    },
    handleInputChange: {
      type: Function,
      default: () => {},
    },
  },

  setup(props) {
    const qtdColunasPorCelula = computed(() => Math.floor(12 / props.qtdColunas))

    const celulas = ref([])

    function inicializarCelulas(qtdLinhas) {
      celulas.value = new Array(qtdLinhas)
      for (let linha = 0; linha < qtdLinhas; linha += 1) {
        celulas.value[linha] = []
      }
    }
    function preencherCelulas(elementos) {
      elementos.forEach((linha, linhaIdx) => {
        linha.forEach(componente => {
          celulas.value[linhaIdx][componente.coluna - 1] = componente
        })
      })
      celulas.value = celulas.value.map(linha => linha.filter(comp => !!comp))
    }
    function gerarCelulas() {
      const { elementos } = props
      inicializarCelulas(elementos.length)
      preencherCelulas(elementos)
    }

    watch(() => props.elementos, gerarCelulas, { immediate: true, deep: true })

    function getCelulaComponenteOptions(componenteData) {
      return new CelulaComponenteOptions({
        ...componenteData,
        readonly: props.readonly,
        valueText: componenteData.ticketsRespostas[0] ? componenteData.ticketsRespostas[0].respostaTexto : null,
        valueBoolean: componenteData.ticketsRespostas[0] ? componenteData.ticketsRespostas[0].respostaBool : false,
        valueOpcaoSelecionadaId: componenteData.ticketsRespostas[0] ? componenteData.ticketsRespostas[0].idFormularioElementoOpcaoResposta : null,
      })
    }

    function getComponenteAssinaturaOptions(componenteData) {
      if (!componenteData.idElementoTipo === TiposDeComponentesEnum.Assinatura) return null
      return new ComponenteAssinaturaOptions({
        ticketId: props.ticketId,
        componenteId: componenteData.id,
        mensagemDeAlerta: 'Este ticket já tem uma assinatura feita e não pode ser alterada.',
        fetchSignature: componenteData.ticketsRespostas?.length > 0,
      })
    }

    function getComponenteArquivoOptions(componenteData) {
      if (!componenteData.idElementoTipo === TiposDeComponentesEnum.Arquivo) return null
      return new ComponenteArquivoOptions({
        ticketId: props.ticketId,
        componenteId: componenteData.id,
        fetchFiles: !!componenteData.ticketsRespostas?.length,
      })
    }

    const rowClasses = computed(() => {
      let classes = ''

      classes += props.justifyCenter ? ' justify-center' : ''
      classes += props.alignCenter ? ' align-center' : ''

      return classes
    })

    return {
      qtdColunasPorCelula,
      celulas,
      getCelulaComponenteOptions,
      getComponenteAssinaturaOptions,
      getComponenteArquivoOptions,
      rowClasses,
      CelulaOptions,
    }
  },
}
</script>
